class SettingsFormSerializer {
    static serialize(params) {
        if(params.key === undefined) {
            params.key = 'COMPANY_CATEGORY_LIMITERS';
        }

        return params;
    }

    static unserialize(settings) {
        return settings;
    }
}

export default SettingsFormSerializer;


// WEBPACK FOOTER //
// ./web/src/services/SettingsFormSerializer.js